export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  if (!base64Url) {
    return null;
  }
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export interface TokenData {
  exp: number;
  iat: number;
  username: string;
  id: string;
  pesel?: string;
  firstName: string;
  lastName: string;
  email?: string | null;
  gdprConsent: boolean;
  notificationsConsent: boolean;
  termsConsent: boolean;
  isPasswordSet: boolean;
  roles: string[];
}

export interface UISettings {
  mobileEmbed?: boolean;
  bgColor?: string;
  application?: {
    hideTitle?: boolean;
  };
}

export class SessionService {

  private static storage = sessionStorage;

  constructor() {
  }

  static SaveUiSettings(settings: UISettings): void {
    this.storage.setItem('ui-settings', JSON.stringify(settings));
  }

  static GetUISettings(): UISettings | null {
    const settings = this.storage.getItem('ui-settings');
    if (settings) {
      return JSON.parse(settings);
    } else {
      return null;
    }
  }

  static Login(token: string, refreshToken: string): void {
    this.storage.setItem('token', token);
    this.storage.setItem('authAt', new Date().getTime().toString());
    this.storage.setItem('sessionKey', refreshToken);
  }

  static Logout(): void {
    this.storage.removeItem('token');
    this.storage.removeItem('sessionKey');
    this.storage.removeItem('authAt');
  }

  static SetAccessToken(token: string): void {
    this.storage.setItem('token', token);
  }

  static RemoveAccessToken(): void {
    this.storage.removeItem('token');
  }

  static GetAccessToken(): string | null {
    return this.storage.getItem('token');
  }

  static GetRefreshToken(): string | null {
    return this.storage.getItem('sessionKey');
  }

  public static GetTokenData(token?: string): TokenData | null {
    const t = token || this.storage.getItem('token');
    const tokenData: TokenData | null = t ? { ...parseJwt(t) } : null;
    if (!tokenData) {
      return null;
    }
    return tokenData;
  }

  public static Authed(): boolean {
    const exp: number = (SessionService.GetTokenData()?.exp || 0) * 1000;
    return ((exp > new Date().getTime()) && exp !== 0);
  }

  public static SetGoBackUrl(url: string): void {
    this.storage.setItem('goBackUrl', url);
  }

  public static GetGoBackUrl(): string | null {
    return this.storage.getItem('goBackUrl');
  }

  public static RemoveGoBackUrl(): void {
    this.storage.removeItem('goBackUrl');
  }

  public static IsCompletedUserData(): boolean {
    const v = SessionService.GetTokenData();
    return !!v?.email && !!v?.gdprConsent && !!v?.termsConsent;
  }
}
